/** @format */

import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const dashboard = createAsyncThunk(
  "dashboard/fetch",
  async (_, { rejectWithValue, serializeError }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/GetEsignLogCount`
      );
      if (response.status && response.data) {
        return response.data;
      } else {
        throw new Error("Unexpected response format or empty data");
      }
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    data: {},
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(dashboard.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(dashboard.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(dashboard.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export default dashboardSlice.reducer;
